// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-text-box[data-v-42757fe1]  .el-alert .el-alert__content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.preview-text-box[data-v-42757fe1]  .el-alert .el-alert__content .to-page-btn{font-weight:bold;font-size:13px}.ml-14[data-v-42757fe1]{margin-left:14px}.ml-10[data-v-42757fe1]{margin-left:10px}.width-450[data-v-42757fe1]{width:450px}.color-909399[data-v-42757fe1]{color:#909399}", ""]);
// Exports
module.exports = exports;
